import { tv } from 'tailwind-variants';
import { FormSubmission } from './submission.tsx';
import type { JSX, ParentProps } from 'solid-js';
import type { VariantProps } from 'tailwind-variants';

type Props = ParentProps<{
	successMessage?: JSX.Element;
}> &
	VariantProps<typeof styles>;

export function FormAction(props: Props) {
	return (
		<div class="flex w-full flex-row flex-wrap items-center justify-start gap-4">
			<div class={styles({ width: props.width })}>{props.children}</div>
			<FormSubmission successMessage={props.successMessage} />
		</div>
	);
}

const styles = tv({
	base: 'flex flex-row-reverse gap-2',
	variants: {
		width: {
			full: 'w-full shrink-0 grow',
			fit: 'w-max shrink grow-0',
		},
	},
	defaultVariants: {
		width: 'fit',
	},
});
